import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: ""
}
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarTogglerDemo02"
}
const _hoisted_5 = { class: "navbar-nav ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleSwitcher = _resolveComponent("LocaleSwitcher")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_LocaleSwitcher),
      _cache[8] || (_cache[8] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarTogglerDemo02",
        "aria-controls": "navbarTogglerDemo02",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.transitionEnter()))
          }, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-link"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Home")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.transitionEnter()))
          }, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: "nav-link"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("About")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.transitionEnter()))
          }, [
            _createVNode(_component_router_link, {
              to: "/portfolio",
              class: "nav-link"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Portfolio")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.transitionEnter()))
          }, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "nav-link"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Contact")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}